var PayableEntity;
(function (PayableEntity) {
    PayableEntity["ApplePay"] = "applebtn";
    PayableEntity["GooglePay"] = "googlebtn";
    PayableEntity["Form"] = "form";
    PayableEntity["Resign"] = "resign";
    PayableEntity["Paypal"] = "paypal";
})(PayableEntity || (PayableEntity = {}));
export default PayableEntity;
